export default {
    Equal: 'equal',
    GreaterThan: 'greater',
    LessThan: 'less',
    Range: 'range',
    Period: 'period',
    Today: 'today',
    Yesterday: 'yesterday',
    Week: 'week',
    Month: 'month',
    Items: () => {
        return [
            //{ id: 'equal', name: `filter-range-type-equal` },
            { id: 'greater', name: `filter:range-type-greater` },
            { id: 'less', name: `filter:range-type-less` },
            { id: 'range', name: `filter:range-type-range` }
        ]
    },
    DateItems: () => {
        return [
            { id: 'period', name: `filter:range-type-period` },
            { id: 'greater', name: `filter:range-type-greater` },
            { id: 'less', name: `filter:range-type-less` },
            { id: 'range', name: `filter:range-type-range` }
        ];
    },
    PeriodItems: () => {
        return [
            { id: 'today', name: 'filter:date-today' },
            { id: 'yesterday', name: 'filter:date-yesterday' },
            { id: 'week', name: 'filter:date-week' },
            { id: 'month', name: 'filter:date-month' }
        ];
    }
};
